import { Component, ElementRef, Input, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InitialsPipe } from "../shared/pipes/intials.pipe";
import { AgentCardComponent } from "../agent-card/agent-card.component";
import { MemberInsurerRestService } from '../../services/member-insurer-rest.service';
import { Subject, takeUntil } from 'rxjs';
import { adminAgentsData, AdminDetails, allAgentslistResponse } from '../../models/phase1models';
import { NoDataFoundComponent } from "../shared/no-data-found/no-data-found.component";
import { LoaderComponent } from "../shared/loader/loader.component";
import { Roles } from '../../models/commonmodel';
import { NotificationService } from '../shared/services/notifications.service';
import { ProviderCardComponent } from "../provider-card/provider-card.component";
@Component({
  selector: 'app-admin-profile',
  standalone: true,
  imports: [MatFormFieldModule, CommonModule, MatInputModule, FormsModule, MatTooltipModule, InitialsPipe, AgentCardComponent, NoDataFoundComponent, LoaderComponent, ProviderCardComponent],
  templateUrl: './admin-profile.component.html',
  styleUrl: './admin-profile.component.scss'
})
export class AdminProfileComponent implements OnInit, OnDestroy {

  @Input() provider: any;

  adminId!: string;
  adminDetails: AdminDetails | null = null;
  role: any;

  status: 'ALL' | 'ACTIVE' | 'DEACTIVE' = 'ALL';
  searchText: string = '';

  allAgents: any[] = [];
  allAgentsTemp: any[] = [];

  filteredAgents: any[] = [];
  currentPage: number = 1;
  pageSize: number = 4; // Adjust based on the number of cards you want per page
  totalPages: number = 0;
  isRotating: boolean = false;

  private ngUnsubscribe = new Subject<void>();

  constructor(
    public router: Router,
    private restService: MemberInsurerRestService,
    private route: ActivatedRoute, private notification: NotificationService
  ) {
    this.adminId = this.route.snapshot.paramMap.get('id') || '';

  }

  ngOnInit() {
    this.getAdminProfileById();
    this.getAllAgents();
  }

  getAdminProfileById(): void {
    if (this.adminId) {
      this.restService.getAdminById(this.adminId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: AdminDetails) => {
            if (res) {
              this.adminDetails = res;
              this.role = this.adminDetails.role;
              console.log("the role is" + this.role)
              console.log(res)
            }
          },
          err => {
            this.adminDetails = null;
            console.error("Error fetching admin details:", err);
          }
        );
    } else {
      console.warn("Admin ID not found in route parameters.");
      this.adminDetails = null;
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  isDataLoading: boolean = false;
  enumRole = Roles;

  getAllAgents(): void {
    this.allAgents = [];
    this.allAgentsTemp = [];
    console.log(this.adminId.charAt(3))
    this.isDataLoading = true;
    console.log(this.adminDetails?.addedBy)
    console.log(this.role)
    const orgid=''
    if (this.adminId.charAt(3) === 'I') {
      this.restService.getAllInsurerAgentList(orgid)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: adminAgentsData[]) => {
            if (res) {
              this.allAgents = res;
              this.allAgentsTemp = res;
              this.applyFiltersAndSearch();
              this.isDataLoading = false;
            }
          },
          err => {
            this.allAgents = [];
            this.filteredAgents = [];
            console.error("Error fetching agent list:", err);
          }
        );
    }
    else if (this.adminId.charAt(3) === 'P') {
      this.restService.getAllProviderAgentList(this.adminId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: adminAgentsData[]) => {
            if (res) {
              this.allAgents = res;
              this.allAgentsTemp = res;
              this.applyFiltersAndSearch();
              this.isDataLoading = false;
            }
          },
          err => {
            this.allAgents = [];
            this.filteredAgents = [];
            console.error("Error fetching agent list:", err);
          }
        );
    }
    else if (this.adminId.charAt(3) === 'D') {
      this.restService.getAllDistributorAgentsList(this.adminId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: adminAgentsData[]) => {
            if (res) {
              this.allAgents = res;
              this.allAgentsTemp = res;
              this.applyFiltersAndSearch();
              this.isDataLoading = false;
            }
          },
          err => {
            this.allAgents = [];
            this.filteredAgents = [];
            this.notification.showNotification(err.error)

            console.error("Error fetching agent list:", err);
          }
        );



    }
  }

  onRouteBack() {
    let tab = 0;

    if (this.role === this.enumRole.ADMIN_DISTRIBUTOR)
      tab = 2;
    else if (this.role === this.enumRole.ADMIN_PROVIDER)
      tab = 1;

    this.router.navigate(['/dashboard/addAdmins'], { queryParams: { tab } });
  }


  copyProfileLink(): void {
    const emailInput = document.getElementById('profileLink') as HTMLInputElement;
    if (emailInput) {
      emailInput.select();
      document.execCommand('copy');
    }
  }

  // ...existing code...

  applyFiltersAndSearch(): void {
    // Always start with the full agent list
    let tempAgents = [...this.allAgents];

    // Apply the search filter
    if (this.searchText.trim()) {
      const searchTerm = this.searchText.toLowerCase().trim();
      tempAgents = tempAgents.filter(agent =>
        (agent.firstName?.toLowerCase().includes(searchTerm) || '') ||
        (agent.lastName?.toLowerCase().includes(searchTerm) || '') ||
        (agent.email?.toLowerCase().includes(searchTerm) || '') ||
        (agent.phone?.includes(searchTerm) || '')
      );
    }

    // Apply status filter
    if (this.status !== 'ALL') {
      tempAgents = tempAgents.filter(agent =>
        agent.status?.toUpperCase() === this.status
      );
    }

    this.filteredAgents = tempAgents;
    this.currentPage = 1; // Reset to the first page after applying filters
    this.totalPages = Math.ceil(this.filteredAgents.length / this.pageSize); // Recalculate total pages
    this.paginateAgents();
  }

  // ...existing code...

  paginatedAgents: any[] = [];

  paginateAgents(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedAgents = this.filteredAgents.slice(start, end);
  }

  onSearchAgent(): void {
    this.applyFiltersAndSearch();
  }

  clearSearch(): void {
    this.searchText = '';
    this.onSearchAgent();
  }

  selectedFilter: 'all' | 'active' | 'inactive' = 'all';
  // ...existing code...

  applyFilter(filterType: 'all' | 'active' | 'inactive'): void {
    this.selectedFilter = filterType;
    // Filter the original list and update allAgents
    this.allAgents = this.getFilteredList(this.allAgentsTemp, filterType);
    // Now apply search and pagination on the filtered list
    this.applyFiltersAndSearch();
  }

  // ...existing code...
  private getFilteredList(list: any[], type: 'all' | 'active' | 'inactive'): any[] {
    if (type === 'active') return list.filter(item => item.isactive);
    if (type === 'inactive') return list.filter(item => !item.isactive);
    return [...list]; // all
  }


  onRefresh(): void {
    this.isRotating = true;
    this.searchText = '';
    this.status = 'ALL';
    this.currentPage = 1;
    this.getAllAgents();
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.paginateAgents();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.paginateAgents();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.paginateAgents();
    }
  }
}